import React, { useState, useEffect } from "react";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import TableSkeleton from "../../components/TableSkeleton";

const AppointmentTable = ({ appointments, isLoading }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Reset page to 1 when appointments data changes
  useEffect(() => {
    setCurrentPage(1);
  }, [appointments]);

  const paginatedAppointments = appointments.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(appointments.length / itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const skeletonColumns = [
    { width: 40, height: 14, className: "p-3" }, // No.
    { width: 80, height: 14, className: "p-3" }, // Appointment ID
    { width: 100, height: 14, className: "p-3" }, // Scheduled Date
    { width: 150, height: 14, className: "p-3" }, // Doctor Name
    { width: 80, height: 14, className: "p-3" }, // Status
  ];

  return (
    <div className="bg-white shadow-sm rounded-lg">
      <div className="overflow-x-auto">
        <table className="min-w-full w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">No.</th>
              <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">Appointment ID</th>
              <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">Scheduled Date</th>
              <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">Doctor Name</th>
              <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">Status</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {isLoading ? (
              <TableSkeleton columns={skeletonColumns} rowCount={itemsPerPage} />
            ) : paginatedAppointments.length === 0 ? (
              <tr>
                <td colSpan={6} className="text-center py-4 text-gray-500">
                  No Appointments Found.
                </td>
              </tr>
            ) : (
              paginatedAppointments.map((item, i) => (
                <tr key={item.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap text-sm">{(currentPage - 1) * itemsPerPage + i + 1}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">{item.id || "N/A"}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">{new Date(item.appointmentDate).toLocaleDateString()}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">{item.doctorName || "N/A"}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span
                      className={`px-2 inline-flex text-xs capitalize leading-5 font-semibold rounded-full ${
                        item.status === "approved" ? "bg-green-100 text-green-800" :
                        item.status === "cancelled" ? "bg-red-100 text-red-800" :
                        "bg-yellow-100 text-yellow-800"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      
      {totalPages > 1 && (
        <div className="p-4 flex justify-end">
          <ul className="inline-flex items-center -space-x-px">
            <li>
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50">
                <MdKeyboardArrowLeft />
              </button>
            </li>
            {[...Array(totalPages)].map((_, i) => (
              <li key={i}>
                <button onClick={() => handlePageChange(i + 1)} className={`px-3 py-2 leading-tight border ${currentPage === i + 1 ? 'bg-blue-50 text-blue-600 border-blue-300' : 'text-gray-500 bg-white border-gray-300 hover:bg-gray-100 hover:text-gray-700'}`}>
                  {i + 1}
                </button>
              </li>
            ))}
            <li>
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50">
                <MdKeyboardArrowRight />
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default AppointmentTable;